<template>
	<div class="jikao-container">
		<div class="inner-container">
			<!-- Left Content: Exam Title -->
			<div class="main-content-wrapper">
				<div class="exam-header" v-if="!isExamFinished && currentFlow && currentFlow.type === 'exam'">
					<div class="exam-title">{{ examHeader.title }}</div>
					<div class="exam-subtitle">{{ examHeader.subtitle }}</div>
				</div>
				<div class="section-content" v-else-if="!isExamFinished && currentFlow">
					<div class="section-title">{{ currentSection && currentSection.name }}</div>
					<div class="instruction-box">{{ currentSection && currentSection.description }}</div>
					<div class="prompt-box" v-if="currentFlow.type === 'passage' || currentFlow.type === 'questions'">
						{{ passagePromptText }}
					</div>
					<div class="question-list" v-if="currentFlow.type === 'questions'">
						<div v-for="(question, index) in currentQuestions" :key="index" class="question-item">
							<div class="question-header">
								<span class="answer-box">( {{ question.answer || '' }} )</span>
								<span class="question-text">{{ currentQuestionStartNumber + index }}.{{ question.name }}</span>
							</div>
							<div class="options-list">
								<div v-for="option in question.options" :key="option.name" class="option-item">
									{{ option.name }}.{{ option.description }}
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 答完卷展示 -->
				<div class="exam-finished-container" v-if="isExamFinished">
					<div class="finished-box" v-if="!isEndPage">
						<div class="finished-text">B卷作答完成，答案上传成功</div>
						<div class="finished-subtext">请您离开机位</div>
					</div>
					<div class="end-page-box" v-else>
						<div class="end-title">机考模拟已结束</div>
						<div class="end-actions">
							<div class="action-btn">重新机考</div>
							<div class="action-btn">重新选题</div>
							<div class="action-btn">查看答案</div>
						</div>
					</div>
				</div>

				<div class="bottom-bar">
					<div class="status-indicator">
						<span class="dot"></span>
						<span class="status-text" v-if="currentFlow && currentFlow.type === 'questions'">10 s</span>
						<span class="status-text" v-else>听指令</span>
					</div>
					<div class="dotted-line"></div>
				</div>
			</div>

			<!-- Right Sidebar -->
			<div class="sidebar">
				<div class="sidebar-header">
					<div class="header-item">
						<div class="label">考 生</div>
						<div class="value-box">
							<img v-if="userInfo.avatar" :src="userInfo.avatar" class="avatar-img" />
							<div v-else class="avatar-placeholder">
								<i class="el-icon-user-solid"></i>
							</div>
						</div>
					</div>
					<div class="header-item">
						<div class="label">机 位</div>
						<div class="value-box seat-num">
							{{ seatNumber }}
						</div>
					</div>
				</div>

				<div class="user-info">
					<div class="info-group">
						<div class="info-label">姓名</div>
						<div class="info-value name">{{ userInfo.name }}</div>
					</div>
					<div class="info-group">
						<div class="info-label">准考证号</div>
						<div class="info-value ticket">{{ userInfo.ticketNumber }}</div>
					</div>
				</div>

				<!-- Question Card -->
				<div class="question-card">
					<div class="card-content">
						<div class="section-group">
							<div class="section-header">
								<span class="section-name">第一节</span>
								<div class="show-answer">
									<i class="el-icon-refresh"></i> 显示答案
								</div>
							</div>
							<div class="question-grid">
								<div v-for="n in 5" :key="n" class="question-item">{{ n }}</div>
							</div>
						</div>

						<div class="section-group">
							<div class="section-header">
								<span class="section-name">第二节</span>
							</div>
							<div class="question-grid">
								<div v-for="n in 15" :key="n + 5" class="question-item">{{ n + 5 }}</div>
							</div>
						</div>
					</div>

					<div class="card-footer">
						<span class="paper-type">A卷</span>
						<span class="status-text">
							<i class="el-icon-edit-outline"></i> 正在作答中
						</span>
					</div>
				</div>

				<div class="volume-control">
					<div class="volume-label">音量调节</div>
					<div class="slider-wrapper">
						<img src="@/assets/svg/volume_icon.svg" alt="volume" class="volume-icon" />
						<el-slider v-model="volume" :min="0" :max="100" @change="handleVolumeChange"></el-slider>
					</div>
				</div>
			</div>
		</div>

		<!-- Floating Step Control -->
		<div class="floating-step-control">
			<div class="step-toggle-btn" @click="isStepPanelVisible = !isStepPanelVisible" title="步骤控制">
				<i class="el-icon-s-operation" v-if="!isStepPanelVisible"></i>
				<i class="el-icon-close" v-else></i>
			</div>
			
			<transition name="fade">
				<div class="step-panel-content" v-show="isStepPanelVisible">
					<div class="step-panel-header">
						<span>步骤控制</span>
					</div>
					<div class="step-list">
						<div v-for="step in displaySteps" :key="step.id" class="step-item"
							:class="{ active: currentStep === step.id }" @click="currentStep = step.id">
							{{ step.name }}
						</div>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
export default {
	name: 'jikao',
	data() {
		return {
			seatNumber: 50,
			userInfo: {
				name: '夏老师',
				ticketNumber: '15256558239',
				avatar: ''
			},
			volume: 50,
			currentStep: 1,
			isStepPanelVisible: false,
			isExamFinished: false,
			finishTimer: null,
			isEndPage: false,
			endTimer: null,
			steps: [],
			exams: [
				{
					type: 'exam',
					name: '普通高等学校招生全国统一考试(安徽卷)英语听力试卷A',
					audio: 'exam_audio.mp3',
					blank: 1.5,
					list: [
						{
							type: 'section',
							name: '第一节(共5小题;每小题1.5分，满分7.5分)',
							description: '听下面5段对话。每段对话后有一个小题，从题中所给的A、B、C三个选项中选出最佳选项。听完每段对话后，你都有10秒钟的时间来回答有关小题和阅读下一小题。每段对话仅读两遍。',
							audio: 'section_audio.mp3',
							blank: 5,
							passages: [
								{
									type: 'passage',
									name: '材料一',
									audio: 'passage_audio.mp3',
									blank: 3,
									questions: [
										{
											type: 'question',
											name: 'What does the woman want the man to do?',
											options: [
												{
													type: 'option',
													name: 'A',
													description: 'A选项'
												},
												{
													type: 'option',
													name: 'B',
													description: 'B选项'
												},
												{
													type: 'option',
													name: 'C',
													description: 'C选项'
												},
											],
											answer: 'A',
											selected: ''
										},
										{
											type: 'question',
											name: 'Where does the conversation probably take place?',
											options: [
												{ type: 'option', name: 'A', description: 'In a library' },
												{ type: 'option', name: 'B', description: 'In a bookstore' },
												{ type: 'option', name: 'C', description: 'In a classroom' }
											],
											answer: 'A',
											selected: ''
										},
										{
											type: 'question',
											name: 'What does the man mean?',
											options: [
												{ type: 'option', name: 'A', description: 'He is busy now' },
												{ type: 'option', name: 'B', description: 'He is very tired' },
												{ type: 'option', name: 'C', description: 'He is quite angry' }
											],
											answer: 'A',
											selected: ''
										},
										{
											type: 'question',
											name: 'How will the woman probably get to the station?',
											options: [
												{ type: 'option', name: 'A', description: 'By bus' },
												{ type: 'option', name: 'B', description: 'By subway' },
												{ type: 'option', name: 'C', description: 'By taxi' }
											],
											answer: 'A',
											selected: ''
										},
										{
											type: 'question',
											name: 'What can we learn from the conversation?',
											options: [
												{ type: 'option', name: 'A', description: 'The man will stay at home' },
												{ type: 'option', name: 'B', description: 'The woman will go shopping' },
												{ type: 'option', name: 'C', description: 'They will go together' }
											],
											answer: 'A',
											selected: ''
										}
									],
								},
							]
						},
						{
							type: 'section',
							name: '第二节(共15小题;每小题1.5分，满分22.5分)',
							description: '听下面5段对话或独白。每段对话或独白后有几个小题，从题中所给的AB、C三个选项中选出最佳选项。听每段对话或独白前，你将有时间阅读各个小题，每小题5秒钟;听完后，各小题将给出5秒钟的作答时间。每段对话或独白读两遍。',
							audio: 'section_audio.mp3',
							blank: 5,
							passages: [
								{
									type: 'passage',
									name: '材料一',
									audio: 'passage_audio.mp3',
									blank: 3,
									questions: [
										{
											type: 'question',
											name: 'What does the woman want the man to do?',
											options: [
												{
													type: 'option',
													name: 'A',
													description: 'A选项'
												},
												{
													type: 'option',
													name: 'B',
													description: 'B选项'
												},
												{
													type: 'option',
													name: 'C',
													description: 'C选项'
												},
											],
											answer: 'A',
											selected: ''
										},
										{
											type: 'question',
											name: 'Where does the conversation probably take place?',
											options: [
												{ type: 'option', name: 'A', description: 'In a library' },
												{ type: 'option', name: 'B', description: 'In a bookstore' },
												{ type: 'option', name: 'C', description: 'In a classroom' }
											],
											answer: 'A',
											selected: ''
										},
										{
											type: 'question',
											name: 'What does the man mean?',
											options: [
												{ type: 'option', name: 'A', description: 'He is busy now' },
												{ type: 'option', name: 'B', description: 'He is very tired' },
												{ type: 'option', name: 'C', description: 'He is quite angry' }
											],
											answer: 'A',
											selected: ''
										},
										{
											type: 'question',
											name: 'How will the woman probably get to the station?',
											options: [
												{ type: 'option', name: 'A', description: 'By bus' },
												{ type: 'option', name: 'B', description: 'By subway' },
												{ type: 'option', name: 'C', description: 'By taxi' }
											],
											answer: 'A',
											selected: ''
										},
										{
											type: 'question',
											name: 'What can we learn from the conversation?',
											options: [
												{ type: 'option', name: 'A', description: 'The man will stay at home' },
												{ type: 'option', name: 'B', description: 'The woman will go shopping' },
												{ type: 'option', name: 'C', description: 'They will go together' }
											],
											answer: 'A',
											selected: ''
										}
									],
								},
								{
									type: 'passage',
									name: '材料一',
									audio: 'passage_audio.mp3',
									blank: 3,
									questions: [
										{
											type: 'question',
											name: 'What does the woman want the man to do?',
											options: [
												{
													type: 'option',
													name: 'A',
													description: 'A选项'
												},
												{
													type: 'option',
													name: 'B',
													description: 'B选项'
												},
												{
													type: 'option',
													name: 'C',
													description: 'C选项'
												},
											],
											answer: 'A',
											selected: ''
										},
										{
											type: 'question',
											name: 'Where does the conversation probably take place?',
											options: [
												{ type: 'option', name: 'A', description: 'In a library' },
												{ type: 'option', name: 'B', description: 'In a bookstore' },
												{ type: 'option', name: 'C', description: 'In a classroom' }
											],
											answer: 'A',
											selected: ''
										},
										{
											type: 'question',
											name: 'What does the man mean?',
											options: [
												{ type: 'option', name: 'A', description: 'He is busy now' },
												{ type: 'option', name: 'B', description: 'He is very tired' },
												{ type: 'option', name: 'C', description: 'He is quite angry' }
											],
											answer: 'A',
											selected: ''
										},
										{
											type: 'question',
											name: 'How will the woman probably get to the station?',
											options: [
												{ type: 'option', name: 'A', description: 'By bus' },
												{ type: 'option', name: 'B', description: 'By subway' },
												{ type: 'option', name: 'C', description: 'By taxi' }
											],
											answer: 'A',
											selected: ''
										},
										{
											type: 'question',
											name: 'What can we learn from the conversation?',
											options: [
												{ type: 'option', name: 'A', description: 'The man will stay at home' },
												{ type: 'option', name: 'B', description: 'The woman will go shopping' },
												{ type: 'option', name: 'C', description: 'They will go together' }
											],
											answer: 'A',
											selected: ''
										}
									],
								},
							]
						},
					]
				},
				{
					type: 'exam',
					name: '普通高等学校招生全国统一考试(安徽卷)英语听力试卷B',
					audio: 'exam_audio.mp3',
					blank: 1.5,
					list: [
						{
							type: 'section',
							name: '第一节(共5小题;每小题1.5分，满分7.5分)',
							description: '听下面5段对话。每段对话后有一个小题，从题中所给的A、B、C三个选项中选出最佳选项。听完每段对话后，你都有10秒钟的时间来回答有关小题和阅读下一小题。每段对话仅读两遍。',
							audio: 'section_audio.mp3',
							blank: 5,
							passages: [
								{
									type: 'passage',
									name: '材料一',
									audio: 'passage_audio.mp3',
									blank: 3,
									questions: [
										{
											type: 'question',
											name: 'What does the woman want the man to do?',
											options: [
												{
													type: 'option',
													name: 'A',
													description: 'A选项'
												},
												{
													type: 'option',
													name: 'B',
													description: 'B选项'
												},
												{
													type: 'option',
													name: 'C',
													description: 'C选项'
												},
											],
											answer: 'A',
											selected: ''
										},
										{
											type: 'question',
											name: 'Where does the conversation probably take place?',
											options: [
												{ type: 'option', name: 'A', description: 'In a library' },
												{ type: 'option', name: 'B', description: 'In a bookstore' },
												{ type: 'option', name: 'C', description: 'In a classroom' }
											],
											answer: 'A',
											selected: ''
										},
										{
											type: 'question',
											name: 'What does the man mean?',
											options: [
												{ type: 'option', name: 'A', description: 'He is busy now' },
												{ type: 'option', name: 'B', description: 'He is very tired' },
												{ type: 'option', name: 'C', description: 'He is quite angry' }
											],
											answer: 'A',
											selected: ''
										},
										{
											type: 'question',
											name: 'How will the woman probably get to the station?',
											options: [
												{ type: 'option', name: 'A', description: 'By bus' },
												{ type: 'option', name: 'B', description: 'By subway' },
												{ type: 'option', name: 'C', description: 'By taxi' }
											],
											answer: 'A',
											selected: ''
										},
										{
											type: 'question',
											name: 'What can we learn from the conversation?',
											options: [
												{ type: 'option', name: 'A', description: 'The man will stay at home' },
												{ type: 'option', name: 'B', description: 'The woman will go shopping' },
												{ type: 'option', name: 'C', description: 'They will go together' }
											],
											answer: 'A',
											selected: ''
										}
									],
								},
							]
						},
					]
				}
			]
		};
	},
	created() {
		this.steps = this.flowSteps.map((_, index) => ({
			id: index + 1,
			name: `步骤${index + 1}`
		}));
	},
	computed: {
		flowSteps() {
			const steps = [];
			// 遍历所有试卷
			(this.exams || []).forEach((exam, examIndex) => {
				steps.push({ type: 'exam', examIndex });
				(exam.list || []).forEach((section, sectionIndex) => {
					steps.push({ type: 'section', examIndex, sectionIndex });
					(section.passages || []).forEach((passage, passageIndex) => {
						steps.push({ type: 'passage', examIndex, sectionIndex, passageIndex });
						steps.push({ type: 'questions', examIndex, sectionIndex, passageIndex });
					});
				});
			});
			return steps;
		},
		// 计算属性：供步骤面板展示的步骤列表
		// 优先返回已缓存的 this.steps；若未初始化，则根据 flowSteps 动态生成
		displaySteps() {
			return this.steps && this.steps.length
				? this.steps
				: this.flowSteps.map((_, index) => ({ id: index + 1, name: `步骤${index + 1}` }));
		},
		currentFlow() {
			return this.flowSteps[this.currentStep - 1] || null;
		},
		currentExam() {
			if (!this.currentFlow) return null;
			return (this.exams || [])[this.currentFlow.examIndex] || null;
		},
		currentSection() {
			if (!this.currentFlow) return null;
			if (this.currentFlow.type === 'exam') return null;
			const exam = this.currentExam;
			if (!exam) return null;
			return (exam.list || [])[this.currentFlow.sectionIndex] || null;
		},
		currentPassage() {
			if (!this.currentFlow) return null;
			if (this.currentFlow.type !== 'passage' && this.currentFlow.type !== 'questions') return null;
			const section = this.currentSection;
			if (!section) return null;
			return (section.passages || [])[this.currentFlow.passageIndex] || null;
		},
		currentQuestions() {
			const passage = this.currentPassage;
			return passage && passage.questions ? passage.questions : [];
		},
		currentQuestionStartNumber() {
			if (!this.currentFlow) return 1;
			if (this.currentFlow.type !== 'questions') return 1;
			return this.getPassageQuestionStartNumber(
				this.currentFlow.examIndex,
				this.currentFlow.sectionIndex,
				this.currentFlow.passageIndex
			);
		},
		/**
		 * 计算属性：passagePromptText
		 * 作用：生成当前材料对应的“听第 X 段材料，回答第 Y-Z 题”提示文案
		 * 触发时机：当 currentFlow 为 passage/questions 类型时，模板会读取该值并渲染到 prompt-box
		 * 逻辑拆解：
		 * 1. 若当前步骤为空，或类型不是 passage/questions，直接返回空串
		 * 2. 取出当前步骤在试卷、章节、材料中的索引
		 * 3. 调用 getPassageQuestionStartNumber 计算该材料第一题在整个试卷中的序号（从 1 开始）
		 * 4. 取出当前材料对象，统计其 questions 长度，计算最后一题序号（保证 end ≥ start）
		 * 5. 调用 formatQuestionRange 将起止序号格式化为“第 Y 题”、“第 Y、Z 题”或“第 Y-Z 题”
		 * 6. 调用 getPassageNumber 计算该材料是整套试卷中的第几段材料（从 1 开始）
		 * 7. 拼接并返回最终提示文案
		 */
		passagePromptText() {
			if (!this.currentFlow) return '';
			if (this.currentFlow.type !== 'passage' && this.currentFlow.type !== 'questions') return '';
			const examIndex = this.currentFlow.examIndex;
			const sectionIndex = this.currentFlow.sectionIndex;
			const passageIndex = this.currentFlow.passageIndex;
			const start = this.getPassageQuestionStartNumber(examIndex, sectionIndex, passageIndex);
			const passage = this.currentPassage;
			const count = passage && passage.questions ? passage.questions.length : 0;
			const end = Math.max(start, start + count - 1);
			const rangeText = this.formatQuestionRange(start, end);
			const passageNo = this.getPassageNumber(examIndex, sectionIndex, passageIndex);
			return `听第${passageNo}段材料，回答${rangeText}。`;
		},
		examHeader() {
			const exam = this.currentExam;
			const name = exam && exam.name ? exam.name : '';
			return this.splitExamName(name);
		}
	},
	watch: {
		/**
		 * 监听 currentStep 的变化
		 * 当切换到最后一步（即步骤序号等于总步骤数）时，启动“完成考试”计时器；
		 * 否则，清除所有与考试结束相关的计时器，并重置 isExamFinished 与 isEndPage 状态，恢复初始考试界面
		 */
		currentStep(newVal) {
			// Check if it's the last step
			if (newVal === this.displaySteps.length) {
				this.startFinishTimer();
			} else {
				this.clearFinishTimer();
				this.clearEndTimer();
				this.isExamFinished = false;
				this.isEndPage = false;
			}
		}
	},
	methods: {
		startFinishTimer() {
			this.clearFinishTimer();
			this.finishTimer = setTimeout(() => {
				this.isExamFinished = true;
				this.startEndTimer();
			}, 5000);
		},
		startEndTimer() {
			this.clearEndTimer();
			this.endTimer = setTimeout(() => {
				this.isEndPage = true;
			}, 5000);
		},
		clearFinishTimer() {
			if (this.finishTimer) {
				clearTimeout(this.finishTimer);
				this.finishTimer = null;
			}
		},
		clearEndTimer() {
			if (this.endTimer) {
				clearTimeout(this.endTimer);
				this.endTimer = null;
			}
		},
		splitExamName(name) {
			if (!name) return { title: '', subtitle: '' };
			const marker = '英语听力试卷';
			const idx = name.indexOf(marker);
			if (idx === -1) return { title: name, subtitle: '' };
			return { title: name.slice(0, idx), subtitle: name.slice(idx) };
		},
		getPassageQuestionStartNumber(examIndex, sectionIndex, passageIndex) {
			let count = 0;
			const exams = this.exams || [];
			for (let e = 0; e < exams.length; e++) {
				const exam = exams[e];
				const sections = exam && exam.list ? exam.list : [];
				for (let s = 0; s < sections.length; s++) {
					const section = sections[s];
					const passages = section && section.passages ? section.passages : [];
					for (let p = 0; p < passages.length; p++) {
						if (e === examIndex && s === sectionIndex && p === passageIndex) {
							return count + 1;
						}
						const qCount = passages[p] && passages[p].questions ? passages[p].questions.length : 0;
						count += qCount;
					}
				}
			}
			return 1;
		},
		getPassageNumber(examIndex, sectionIndex, passageIndex) {
			let count = 0;
			const exams = this.exams || [];
			for (let e = 0; e < exams.length; e++) {
				const exam = exams[e];
				const sections = exam && exam.list ? exam.list : [];
				for (let s = 0; s < sections.length; s++) {
					const section = sections[s];
					const passages = section && section.passages ? section.passages : [];
					for (let p = 0; p < passages.length; p++) {
						count += 1;
						if (e === examIndex && s === sectionIndex && p === passageIndex) return count;
					}
				}
			}
			return passageIndex + 1;
		},
		formatQuestionRange(start, end) {
			if (start === end) return `第${start}题`;
			if (end === start + 1) return `第${start}、${end}题`;
			return `第${start}-${end}题`;
		},
		handleVolumeChange(val) {
			console.log('Volume changed:', val);
		}
	}
};
</script>

<style lang="scss" scoped>
.jikao-container {
	display: flex;
	justify-content: center;
	height: 100vh;
	background-color: #f0f2f5;

	.inner-container {
		display: flex;
		width: 1200px;
		height: 100%;
		background-color: #fff;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
	}
}

/* Left Content Styles */
.main-content-wrapper {
	flex: 1;
	display: flex;
	flex-direction: column;
	position: relative;

	.exam-header {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding-bottom: 60px;

		.exam-title {
			font-size: 32px;
			font-weight: bold;
			color: #0080ff;
			margin-bottom: 20px;
		}

		.exam-subtitle {
			font-size: 28px;
			font-weight: bold;
			color: #0080ff;
		}
	}

	.section-content {
		flex: 1;
		display: flex;
		flex-direction: column;
		padding: 40px 60px;
		overflow-y: auto;
		min-height: 0;

		.section-title {
			font-size: 24px;
			font-weight: bold;
			color: #000;
			margin-bottom: 20px;
			flex-shrink: 0;
		}

		.instruction-box {
			background-color: #e6f3ff;
			border-radius: 8px;
			padding: 20px;
			font-size: 16px;
			line-height: 1.6;
			color: #333;
			text-align: justify;
			margin-bottom: 30px;
			flex-shrink: 0;
		}

		.prompt-box {
			padding: 15px 20px;
			font-weight: bold;
			font-size: 16px;
			color: #000;
			background-color: #fff;
			align-self: flex-start;
			margin-bottom: 20px;
		}

		.question-list {
			.question-item {
				margin-bottom: 30px;

				.question-header {
					display: flex;
					align-items: center;
					margin-bottom: 15px;
					font-size: 18px;
					font-weight: bold;
					color: #333;

					.answer-box {
						min-width: 40px;
						display: inline-flex;
						justify-content: center;
						margin-right: 15px;
						color: #0080ff;
						font-family: monospace;
					}
				}

				.options-list {
					padding-left: 60px;

					.option-item {
						margin-bottom: 10px;
						font-size: 16px;
						color: #666;
					}
				}
			}
		}
	}

	.bottom-bar {
		height: 60px;
		background-color: #0080ff;
		display: flex;
		align-items: center;
		padding: 0 30px;
		color: #fff;

		.status-indicator {
			display: flex;
			align-items: center;
			margin-right: 20px;
			flex-shrink: 0;

			.dot {
				width: 10px;
				height: 10px;
				background-color: #67c23a;
				border-radius: 50%;
				margin-right: 10px;
				box-shadow: 0 0 4px rgba(255, 255, 255, 0.5);
			}

			.status-text {
				font-size: 18px;
				font-weight: bold;
			}
		}

		.dotted-line {
			flex: 1;
			height: 0;
			border-bottom: 2px dotted rgba(255, 255, 255, 0.6);
			margin-top: 5px;
		}
	}
}

/* Right Sidebar Styles */
.sidebar {
	width: 300px;
	background-color: #e6f3ff;
	padding: 40px 20px 0 20px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;

	.sidebar-header {
		display: flex;
		justify-content: space-between;
		margin-bottom: 20px;

		.header-item {
			flex: 1;
			text-align: center;

			.label {
				font-size: 18px;
				font-weight: bold;
				margin-bottom: 10px;
				color: #333;
			}

			.value-box {
				background-color: #fff;
				border: 1px solid #dcdfe6;
				height: 80px;
				display: flex;
				align-items: center;
				justify-content: center;
				margin: 0 5px;

				&.seat-num {
					font-size: 36px;
					color: #0080ff;
					font-weight: bold;
				}

				.avatar-img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}

				.avatar-placeholder {
					font-size: 40px;
					color: #ccc;
				}
			}
		}
	}

	.user-info {
		margin-bottom: 20px;
		padding: 0 10px;

		.info-group {
			margin-bottom: 15px;

			.info-label {
				font-size: 14px;
				color: #666;
				margin-bottom: 5px;
			}

			.info-value {
				font-size: 16px;
				color: #0080ff;
				font-weight: bold;

				&.ticket {
					font-family: Arial, sans-serif;
				}
			}
		}
	}

	/* Question Card Styles */
	.question-card {
		background-color: #fff;
		border-radius: 8px;
		padding: 20px;
		flex: 1;
		/* Fill remaining height */
		display: flex;
		flex-direction: column;
		min-height: 0;
		/* Important for nested scrolling */
		margin-bottom: 20px;
		/* Space before volume control */
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

		.card-content {
			flex: 1;
			overflow-y: auto;
			padding-right: 5px;
			/* Prevent scrollbar overlapping content slightly */

			/* Custom scrollbar for webkit */
			&::-webkit-scrollbar {
				width: 6px;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #dcdfe6;
				border-radius: 3px;
			}

			&::-webkit-scrollbar-track {
				background-color: #f5f7fa;
			}
		}

		.section-group {
			margin-bottom: 20px;

			.section-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 10px;

				.section-name {
					font-weight: bold;
					font-size: 14px;
					color: #333;
				}

				.show-answer {
					font-size: 12px;
					color: #666;
					cursor: pointer;
					display: flex;
					align-items: center;

					i {
						margin-right: 4px;
					}
				}
			}

			.question-grid {
				display: flex;
				flex-wrap: wrap;
				gap: 10px;

				.question-item {
					width: 32px;
					height: 32px;
					border: 1px solid #dcdfe6;
					border-radius: 4px;
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 14px;
					color: #333;
					cursor: pointer;

					&:hover {
						border-color: #0080ff;
						color: #0080ff;
					}

					&.active {
						background-color: #0080ff;
						color: #fff;
						border-color: #0080ff;
					}
				}
			}
		}

		.card-footer {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-top: 20px;
			padding-top: 15px;
			border-top: 1px solid #f0f0f0;

			.paper-type {
				font-size: 18px;
				font-weight: bold;
				color: #0080ff;
			}

			.status-text {
				font-size: 12px;
				color: #0080ff;
				display: flex;
				align-items: center;

				i {
					margin-right: 4px;
				}
			}
		}
	}

	.volume-control {
		border-top: 1px solid #d0e0f0;
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		margin-top: 20px;

		.volume-label {
			position: absolute;
			top: 0;
			left: 50%;
			transform: translate(-50%, -50%);
			background-color: #e6f3ff;
			padding: 0 10px;
			color: #666;
			font-size: 14px;
		}

		.slider-wrapper {
			display: flex;
			align-items: center;
			width: 100%;
			padding: 0 10px;

			.volume-icon {
				font-size: 24px;
				margin-right: 15px;
				color: #333;
				width: 30px;
				height: 30px;
			}

			.el-slider {
				flex: 1;
			}
		}
	}
}

/* Floating Step Control Styles */
.floating-step-control {
	position: fixed;
	left: 20px;
	bottom: 20px;
	z-index: 9999;
	display: flex;
	flex-direction: column-reverse;
	align-items: flex-start;

	.step-toggle-btn {
		width: 40px;
		height: 40px;
		background-color: #0080ff;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		box-shadow: 0 2px 10px rgba(0, 128, 255, 0.4);
		transition: all 0.3s;
		z-index: 10001;

		&:hover {
			transform: scale(1.1);
			background-color: #0066cc;
		}
	}

	.step-panel-content {
		background-color: rgba(0, 0, 0, 0.7);
		border-radius: 8px;
		padding: 10px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		width: 300px;
		max-height: 400px;
		overflow-y: auto;
		backdrop-filter: blur(5px);
		margin-bottom: 15px; /* Space between content and toggle button */
		transform-origin: bottom left;

		/* Scrollbar styling */
		&::-webkit-scrollbar {
			width: 4px;
		}
		
		&::-webkit-scrollbar-thumb {
			background-color: rgba(255, 255, 255, 0.3);
			border-radius: 2px;
		}

		.step-panel-header {
			color: #fff;
			font-size: 14px;
			font-weight: bold;
			margin-bottom: 10px;
			padding-bottom: 5px;
			border-bottom: 1px solid rgba(255, 255, 255, 0.2);
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		.step-list {
			display: flex;
			flex-wrap: wrap;
			gap: 8px;

			.step-item {
				padding: 6px 12px;
				background-color: rgba(255, 255, 255, 0.2);
				border: 1px solid rgba(255, 255, 255, 0.3);
				border-radius: 4px;
				cursor: pointer;
				font-size: 12px;
				color: #fff;
				transition: all 0.2s;
				white-space: nowrap;

				&:hover {
					background-color: rgba(255, 255, 255, 0.3);
				}

				&.active {
					background-color: #0080ff;
					border-color: #0080ff;
					color: #fff;
					font-weight: bold;
					box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
				}
			}
		}
	}
}

/* Transition effects */
	.fade-enter-active,
	.fade-leave-active {
		transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0;
		transform: translateY(20px) scale(0.9);
	}

	/* Exam Finished Styles */
	.exam-finished-container {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #fff;
		border-radius: 8px;
		margin-bottom: 20px;

		.finished-box {
			background-color: #f0faff;
			border-radius: 12px;
			padding: 40px 80px;
			text-align: center;
			box-shadow: 0 4px 12px rgba(0, 128, 255, 0.05);

			.finished-text {
				font-size: 24px;
				font-weight: bold;
				color: #0080ff;
				margin-bottom: 15px;
			}

			.finished-subtext {
				font-size: 20px;
				font-weight: bold;
				color: #0080ff;
			}
		}

		.end-page-box {
			background-color: #f0faff;
			border-radius: 12px;
			padding: 40px 80px;
			text-align: center;
			box-shadow: 0 4px 12px rgba(0, 128, 255, 0.05);
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;

			.end-title {
				font-size: 28px;
				font-weight: bold;
				color: #0080ff;
				margin-bottom: 30px;
				letter-spacing: 2px;
			}

			.end-actions {
				display: flex;
				gap: 15px;

				.action-btn {
					background-color: #0080ff;
					color: white;
					padding: 10px 24px;
					border-radius: 6px;
					font-size: 14px;
					cursor: pointer;
					transition: background-color 0.2s;

					&:hover {
						background-color: #0066cc;
					}
				}
			}
		}
	}
</style>
